import { useCallback, useRef, useState } from 'react';

/**
 * Prevents multiple navigations on double-click (e.g. NA-4399).
 * Returns a stable click handler and whether navigation was already triggered.
 */
export function useNavigateOnce(url: string | null): {
  handleClick: () => void;
  isTriggered: boolean;
} {
  const triggeredRef = useRef(false);
  const [isTriggered, setIsTriggered] = useState(false);

  const handleClick = useCallback(() => {
    if (!url || triggeredRef.current) return;
    triggeredRef.current = true;
    setIsTriggered(true);
    window.location.href = url;
  }, [url]);

  return { handleClick, isTriggered };
}
